import { render, staticRenderFns } from "./BookingForm.vue?vue&type=template&id=1b8915dd&scoped=true"
import script from "./BookingForm.vue?vue&type=script&lang=ts"
export * from "./BookingForm.vue?vue&type=script&lang=ts"
import style0 from "./BookingForm.vue?vue&type=style&index=0&id=1b8915dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8915dd",
  null
  
)

export default component.exports